/** Admin users: the list, the editor and the role names. */
export default {
    roles: {
        superAdmin: 'Super admin',
        admin: 'Admin',
        editor: 'Editor',
        designer: 'Designer',
    },
    shared: {
        newUser: 'New user',
        role: 'Role',
        websites: 'Websites',
        lastLogin: 'Last login',
    },
    list: {
        title: 'Users',
        impersonate: 'Impersonate',
        confirmImpersonate: "Sign in as {email}? You'll see the admin exactly as they do until you exit impersonation.",
        empty: 'No users yet.',
    },
    edit: {
        created: 'User created',
        confirmDelete: 'Delete user {email}?',
        websitesHint: 'Tick every website this user should have access to.',
        password: 'Password',
        passwordHint: 'Leave blank to keep the current password.',
    },
};
